import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faGithub, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons'
import data from '../FakeData/index.json'

function SocialMedia({ social }) {
    let links = ''
    if (social === 'facebook') {
        links = `${data[0].social.facebook}`
        return (<li className={`${social}`}><a href={`${links}`}><FontAwesomeIcon icon={faFacebookF} />   {String(social).charAt(0).toUpperCase() + String(social).slice(1)}</a></li>)
    }
    if (social === 'linkedin') {
        links = `${data[0].social.linkedin}`
        return (<li className={`${social}`}><a href={`${links}`}><FontAwesomeIcon icon={faLinkedinIn} /> {String(social).charAt(0).toUpperCase() + String(social).slice(1)}</a></li>)
    }
    if (social === 'twitter') {
        links = `${data[0].social.twitter}`
        return (<li className={`${social}`}><a href={`${links}`}><FontAwesomeIcon icon={faTwitter} />   {String(social).charAt(0).toUpperCase() + String(social).slice(1)}</a></li>)
    }
    if (social === 'github') {
        links = `${data[0].social.github}`
        return (<li className={`${social}`}><a href={`${links}`}><FontAwesomeIcon icon={faGithub} /> {String(social).charAt(0).toUpperCase() + String(social).slice(1)}</a></li>)
    }
}

export default SocialMedia
